import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CereriComponent } from './cereri.component';
import { MaterialModule } from 'src/app/material.module';
import { DataTablesModule } from 'angular-datatables';
import { CereriDetaliiComponent } from './cereri-detalii/cereri-detalii.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CereriIstoricComponent } from './cereri-istoric/cereri-istoric.component';
import { ActiuniCerereCardModule } from 'src/app/shared/actiuni-cerere-card/actiuni-cerere-card.module';
import { SubsemnatModule } from 'src/app/shared/subsemnat/subsemnat.module';
import { DocumentGenerabilComponent } from './cereri-detalii/document-generabil/document-generabil.component';
import { CerereSabloaneComponent } from './cereri-detalii/cerere-sabloane/cerere-sabloane.component';
import { CerereValidareComponent } from './cereri-detalii/cerere-validare/cerere-validare.component';
import { EditDocumentOficialComponent } from './cereri-detalii/document-generabil/edit-document-oficial/edit-document-oficial.component';
import { IstoricDocumentGenerabilComponent } from './cereri-detalii/document-generabil/istoric-document-generabil/istoric-document-generabil.component';
import { ActualizareCerereComponent } from './cereri-detalii/actualizare-cerere/actualizare-cerere.component';
import { CereriAsigneazaComponent } from './cereri-asigneaza/cereri-asigneaza.component';
import { CereriStatusComponent } from './cereri-status/cereri-status.component';
import { InformatiiAditionaleComponent } from './cereri-detalii/informatii-aditionale/informatii-aditionale.component';
import { ModalInchidereLucrareComponent } from './cereri-detalii/modal-inchidere-lucrare/modal-inchidere-lucrare.component';
import { CerereDetaliiSabloaneComponent } from './cereri-detalii/sabloane/cerere-detalii-sabloane.component';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { RegistruValabilityComponent } from './cereri-detalii/registru-valability/registru-valability.component';
import { UpdateGenerabilValabilityComponent } from './cereri-detalii/document-generabil/update-generabil-valability/update-generabil-valability.component';
import { AddSemnatariComponent } from './cereri-detalii/add-semnatari/add-semnatari.component';

@NgModule({
  declarations: [
    CereriComponent,
    CereriDetaliiComponent,
    CereriIstoricComponent,
    DocumentGenerabilComponent,
    CerereSabloaneComponent,
    CerereValidareComponent,
    EditDocumentOficialComponent,
    IstoricDocumentGenerabilComponent,
    ActualizareCerereComponent,
    CereriAsigneazaComponent,
    CereriStatusComponent,
    InformatiiAditionaleComponent,
    ModalInchidereLucrareComponent,
    CerereDetaliiSabloaneComponent,
    RegistruValabilityComponent,
    UpdateGenerabilValabilityComponent,
    AddSemnatariComponent,
  ],
  imports: [
    ActiuniCerereCardModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    DataTablesModule,
    SubsemnatModule,
    PipesModule,
  ],
  exports: [CereriComponent],
})
export class CereriModule {}
